// extracted by mini-css-extract-plugin
export default {"benefits":"styles_benefits__2Emy8","button_link":"styles_button_link__T+UIU"};